<template>
  <span v-if="obj.description || obj.branch">
    <span v-if="prefix">{{prefix}}</span>
    <span v-if="obj.description">{{obj.description}}</span>
    <span v-if="!obj.description">{{obj.branch}}</span>
  </span>
</template>

<script>
  export default {
    name: 'description',
    props: {
      obj: {
        type: Object,
        default: null
      },
      prefix: {
        type: String
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/common/description.vue